import request from '@/utils/request'

export function add(disease) {
  return request({
    url: '/InfoTherapy/addData',
    method: 'post',
    data: disease
  })
}

export function edit(disease) {
  return request({
    url: '/InfoTherapy/editData',
    method: 'post',
    data: disease
  })
}

export function getById(id) {
  return request({
    url: `/InfoTherapy/getById/${id}`,
    method: 'post'
  })
}
